"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("isomorphic-fetch");
var _headers = require("../../../services/fetch/headers");
var _config = _interopRequireDefault(require("../../../consts/config"));
const handleResponse = json => {
  if (!("error_code" in json)) {
    return {
      token: json.token
    };
  }
  switch (json.error_code) {
    case "INVALID_VERIFICATION":
      return {
        error: "INVALID_VERIFICATION"
      };
    case "INVALID_PASSCODE":
      return {
        error: "INVALID_PASSCODE"
      };
    case "TOO_MANY_OTP_VERIFY_ATTEMPTS":
      return {
        error: "TOO_MANY_OTP_VERIFY_ATTEMPTS"
      };
    default:
      return {
        error: "UNKNOWN"
      };
  }
};
const otpVerify = ({
  transactionId,
  passcode
}) => {
  const payload = {
    transaction_id: transactionId,
    passcode
  };
  return fetch(`${_config.default.apiAuthUrl}/v1/user.otpVerify`, {
    method: "POST",
    headers: (0, _headers.getBasicHeaders)(),
    body: JSON.stringify(payload)
  }).then(response => {
    if (response.status >= 400) {
      return Promise.reject(new Error("API error when initializing OTP login"));
    }
    return response.json();
  }).then(handleResponse);
};
var _default = otpVerify;
exports.default = _default;